module.exports = __webpack_public_path__ + "img/hair_back_female_very_short.df165e80.png";